import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Result, Spin, Tabs } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import PlanEndedNotice from "components/General/PlanEndedNotice";
import { fetchAgentKnowledge } from "util/agentKnowledgeApi";
import AgentKnowledgeTab from "./AgentKnowledgeTab";
import DisclosureTab from "./DisclosureTab";
import QuestionBankTab from "./QuestionBankTab";
import { normalizeAppLanguage } from "util/locale";
import { forgetKnowledgeTopics } from "./useKnowledgeTopics";
import surveyStyles from "../../SurveyManagement/style.module.scss";
import pageStyles from "../style.module.scss";
import styles from "./style.module.scss";

// Sonic Survey → Settings: what every voice survey of the company shares.
const SurveySettingsPage = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(async () => {
    const res = await fetchAgentKnowledge();
    if (!res || res.error) {
      setFailed(true);
      return;
    }
    setFailed(false);
    setData(res);
    forgetKnowledgeTopics(res.topics);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className={pageStyles.page}>
      <Button type="link" className={styles.backLink} onClick={() => history.push("/console/sonic-survey")}>
        <ArrowLeftOutlined /> {t("surveySettings.back")}
      </Button>
      <div className={pageStyles.pageHeader}>
        <div className={pageStyles.pageHeaderText}>
          <h1 className={surveyStyles.pageTitle}>{t("surveySettings.title")}</h1>
          <p className={surveyStyles.pageSubtitle}>{t("surveySettings.subtitle")}</p>
        </div>
      </div>
      {data?.read_only ? <PlanEndedNotice product="survey" /> : null}
      <div className={surveyStyles.contentPanel}>
        {failed ? (
          <Result
            status="warning"
            title={t("surveySettings.load_failed")}
            extra={<Button onClick={load}>{t("surveySettings.retry")}</Button>}
          />
        ) : !data ? (
          <Spin />
        ) : (
          <Tabs
            items={[
              {
                key: "knowledge",
                label: t("surveySettings.tab_knowledge"),
                children: <AgentKnowledgeTab data={data} onChanged={load} />,
              },
              {
                key: "bank",
                label: t("surveySettings.tab_bank"),
                children: <QuestionBankTab topics={data.topics} primaryLanguage={normalizeAppLanguage(i18n.language)} />,
              },
              {
                key: "disclosure",
                label: t("surveySettings.tab_disclosure"),
                children: <DisclosureTab data={data} onChanged={load} />,
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default SurveySettingsPage;
